/* eslint-disable @typescript-eslint/no-explicit-any */
import React from 'react';

interface Props {
  label?: React.ReactNode;
  value?: string;
  placeholder?: string;
  rows?: number;
  textarea?: boolean;
  name: string;
  onChange?: (e: React.SyntheticEvent) => any;
  readOnly?: boolean;
  additionalClasses?: string;
  maxLength?: number;
  required?: boolean;
  textTransform?: 'uppercase' | 'lowercase' | 'capitalize' | 'none';
}

const InputText = ({ label, textarea, additionalClasses, textTransform = 'none', ...restProps }: Props) => {
  return (
    <div className={`input-text form-control${additionalClasses ? ' ' + additionalClasses : ''}`}>
      <label htmlFor={restProps.name}>{label}</label>
      {textarea ? (
        <textarea style={{ textTransform }} {...restProps} />
      ) : (
        <input style={{ textTransform }} type="text" {...restProps} />
      )}
    </div>
  );
};

export default InputText;
